
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import ScoreModel from '../score.mode'

import { ListCard } from '@/components'

@Component({
  components: {
    ListCard
  },
  filters: {
    formatScore: (value: number) => (value * 100).toPrecision(3)
  }
})
export default class ScoreItem extends Vue {
  @Prop({
    default: () => [
      {
        deviceId: 'PS-NIO-ffa62be5-0994b37a',
        deviceName: '蔚来换电站 烟台红星美凯龙建材商场',
        overallScore: 98.7,
        mechanicalScore: 97.6,
        bayboltScore: 99.8
      },
      {
        deviceId: 'PS-NIO-ffa62be5-0994b37a',
        deviceName: '蔚来换电站 烟台红星美凯龙建材商场',
        overallScore: 98.7,
        mechanicalScore: 97.6,
        bayboltScore: 99.8
      }
    ]
  })
  private list!: ScoreModel[]

  @Prop({ default: 0 }) private startIndex!: number

  @Prop() private activeIndex!: number

  @Watch('list')
  watchList() {
    this.state.activeIndex = this.activeIndex
  }

  @Watch('activeIndex')
  watchActiveIndex(value: number) {
    this.state.activeIndex = value
  }

  state = {
    activeIndex: -1
  }

  @Emit('select')
  handleSelect(value: ScoreModel, index: number) {
    this.state.activeIndex = index
    return value
  }

  mounted() {
    if (typeof this.activeIndex !== undefined) {
      this.state.activeIndex = this.activeIndex
    }
  }
}
